/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */

qds-button {
  --qds-control-segmented-item-small-padding-horizontal: 12px;
  --qds-control-segmented-item-standard-padding-horizontal: 16px;
  --qds-control-segmented-item-large-padding-horizontal: 20px;
  --qds-control-border-radius: var(
    --qds-control-toggle-indicator-border-radius
  );
  --qds-control-button-small-padding-horizontal: var(
    --qds-control-segmented-item-small-padding-horizontal
  );
  --qds-control-button-standard-padding-horizontal: var(
    --qds-control-segmented-item-standard-padding-horizontal
  );
  --qds-control-button-large-padding-horizontal: var(
    --qds-control-segmented-item-large-padding-horizontal
  );
  --qds-theme-interactive-background-pressed: var(
    --qds-theme-control-background
  );

  width: 100%;
}

[data-selected],
qds-button:has(:disabled):active {
  background-color: var(--qds-theme-control-background);
  border-radius: var(--qds-control-border-radius);
}

:not([data-selected]) {
  --qds-theme-control-border: transparent;
}

qds-tooltip {
  padding: 8px;
  border-radius: 4px;
  font: var(--qds-control-small-text);
}
